import { useContext, useEffect, useState } from 'react';
import { HyruleToken } from '@nintendo/hyrule-react-commons';
import Utils from '../../../shared/Utils';
import { GameRecommendationApiModel } from '../../../api/models';
import { GameRecommendationsApi } from '../../../api';
import HyruleTokenContext from '../../contexts/HyruleTokenContext';

interface GameRecommendationsHookData {
    recommendations: string[];
    loading: boolean;
    error: boolean;
}

export const useGameRecommendations = (
    naid: string,
    correlationId: string,
): GameRecommendationsHookData => {
    const [recommendations, setRecommendations] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const hyruleToken: HyruleToken = useContext(HyruleTokenContext);

    const getGameRecommendations = async (): Promise<void> => {
        setLoading(true);
        try {
            const gameRecommendationApiModel: GameRecommendationApiModel =
                await GameRecommendationsApi.getGameRecommendations(
                    naid,
                    hyruleToken,
                    correlationId,
                );
            setRecommendations(
                GameRecommendationsApi.mapToGameRecommendationEntries(gameRecommendationApiModel),
            );
            setError(false);
        } catch (error) {
            setRecommendations([]);
            setError(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (Utils.isValidNAID(naid) && hyruleToken.accessToken) getGameRecommendations();
        else setRecommendations([]);
    }, [naid, hyruleToken]);

    return {
        recommendations,
        loading,
        error,
    };
};
